import {useState, useEffect } from 'react';
import Product from '../Product/Product';
import { useSelector,useDispatch } from 'react-redux';
import { uiActions } from '../../store';
import styles from './ProductList.module.css'


export default function ProductList({seriesIds, thumbSize, handleSelect,dropdownFilters,searchValue,collectionFilterColumnName}) {


    const dispatch = useDispatch();
    const [productData, setproductData] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState();
    const selString = useSelector((state) => state.visualizer.selString);
    const activeSurface = useSelector(state => state.visualizer.activeSurface);
    const appliedProducts = useSelector(state => state.visualizer.appliedProducts);


    console.log()

    const handleProductSelect = function(product) {


        if(product.id != selectedProduct){
            handleSelect(product);
        }
    }

     useEffect(() => {

        const selectedProduct = appliedProducts?.[activeSurface?.location ?? 'chamViz']?.[activeSurface?.name] ?? null;

        setSelectedProduct(!selectedProduct ? -1 : selectedProduct.colorway.id);

    }, [activeSurface,appliedProducts]); 

    
    useEffect(() => {
        // normalize to array
        const ids = Array.isArray(seriesIds) ? seriesIds : [seriesIds];
        Promise.all(
            ids.filter(Boolean).map((id) =>
            fetch(`https://lizard.chameleonpower.com/CDN/ProductsBySeries/${id}.json`).then((r) =>
                r.json()
            )
            )
        ).then((lists) => {
            // merge results (no dedupe; add if you need)
            let filteredData = [].concat(...lists);

            if (searchValue.length > 0) {
            filteredData = filteredData.filter((prod) =>
                prod['color'].toLowerCase().includes(searchValue.toLowerCase())
            );
            }

            if (Object.keys(dropdownFilters || {}).length > 0) {
            Object.entries(dropdownFilters).forEach(([column, value]) => {
                if (value && value != -1) {
                filteredData = filteredData.filter((prod) => prod[column] === value);
                }
            });
            }

            filteredData.sort((a, b) => a.name.localeCompare(b.name));
            setproductData(filteredData);
        });
    }, [seriesIds, dropdownFilters, searchValue]);

    

    //console.log('selectedProduct',selectedProduct)
    let productItems = productData.map(product => <Product 
        key={product.id}
        focus={500}
        size={thumbSize} 
        product={product}
        onSelect={() => handleProductSelect(product)}
        isActive={product.id === selectedProduct?true:false}
        collectionFilterColumnName={collectionFilterColumnName}
        />)

    return(
        <ul className={styles.productList} data-series={seriesIds}>
            {productItems}
        </ul>
    );
}